import styled from 'styled-components';
import theme from '../../styles/theme.css';

export const Nav = styled.nav`
    height: ${theme.headerHeight};
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: #FFF;
    padding: 0 1rem;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 5;
    @media (max-width: 680px){
         padding: 0 0.5rem;
        }
    div{
        display: flex;
        justify-content: center;
        align-items: center;
        @media (max-width: 680px){
            max-width: calc(96% / 3);
            &:nth-child(1){
                margin-right: 2%;
            }
        }
    
    }
    .logo{
        width: 120px;
        max-width: 120px;
        @media (max-width: 680px){
            max-width: 100px;
            width: 100px;
            img{
                width: calc(100vw / 3)!important;
                padding: 5px!important;
            }
            svg{
                width: calc(100vw / 3)!important;
                padding: 5px!important; 
            }
        }
        svg{
            width: 95%;
            height: auto;
        }
        img{
            width: 100%!important;
        }
    }
`